module.exports = __webpack_public_path__ + "img/Sycamore 480x480 v2.1a359791.png";